<template>
    <div class="ui-checkbox-consent">
        <label class="ui-checkbox-consent__label">
            <input
                type="checkbox"
                :checked="checked"
                @change="$emit('change', $event.target.checked)"
            />

            <span class="ui-checkbox-consent__mark" :class="{'_error': isError}">
                <span class="_square" />
            </span>

            <span class="ui-checkbox-consent__title">
                Соглашаюсь с условиями <a v-bind:href="urls.oferta" target="_blank">публичной оферты</a> и <a
                v-bind:href="urls.policy" target="_blank">политики конфиденциальности</a> и даю <a
                v-bind:href="urls.consent" target="_blank">согласие на обработку персональных данных</a> <span v-if="isSubscribe">для получения маркетинговых рассылок</span>
            </span>
        </label>

        <div class="ui-checkbox-consent__error" v-if="isError">
            Пожалуйста, проверьте, что вы согласны с условиями
        </div>
    </div>
</template>

<script>
import config from '~/config';

export default {
    name: 'ui-checkbox-consent',
    model: {
        prop: 'checked',
        event: 'change',
    },
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        isError: {
            type: Boolean,
            default: false,
        },
        isSubscribe: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            urls: {
                oferta: config.urls.oferta,
                policy: config.urls.policy,
                consent: config.urls.consent,
            },
        };
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.ui-checkbox-consent {
    user-select: none;

    &__label {
        display: flex;
        gap: 8px;
        cursor: pointer;
    }

    &__mark {
        flex-shrink: 0;
        margin-top: 4px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 12px;
        height: 12px;
        border: 1px solid black;
        transition: all 0.15s ease;

        svg {
            display: none;
            color: black;
        }

        &._error {
            border-color: @color-accent-warm;
        }
    }

    &__title {
        .typography-body-md();
    }

    &__error {
        margin-top: 16px;
        color: @color-accent-warm;
    }

    input[type="checkbox"] {
        display: none;
        visibility: hidden;
    }

    input[type="checkbox"]:checked + .ui-checkbox-consent__mark {
        svg {
            display: block;
        }
        ._square {
            width: 8px;
            height: 8px;
            background-color: black;
        }
    }
}
</style>
